import { PaletteOptions } from '@mui/material/styles/createPalette'

declare module '@mui/material/styles/createPalette' {
  export interface TypeText {
    primary: string
    secondary: string
    disabled: string
    selected: string
    warning: string
  }

  interface HoverOptions {
    primary: '#024462'
  }

  export interface PaletteOptions {
    border?: {
      primary?: string
      selected?: string
    }
    text?: Partial<TypeText>
    hover?: HoverOptions
    plans?: Record<string, { primary: string; text: string }>
    lime?: Partial<any>
    yellow?: Partial<any>
  }
}

export const defaultThemePaletteOptions: PaletteOptions = {
  primary: {
    main: '#0076A8',
    '100': '#E0EFF5',
    '200': '#C4E0EB',
    '300': '#A8D0E1',
    '700': '#3894BB',
    '800': '#1C85B2',
    '900': '#115F7D',
    dark: '#024462'
  },
  secondary: {
    main: '#323232'
  },
  action: {
    hover: '#F6F6F6',
    selected: '#E0EFF5'
  },
  text: {
    primary: '#333333',
    selected: '#0076A8',
    warning: '#CC9C00'
  },
  border: {
    primary: '#C4E0EB',
    selected: '#8CC1D8'
  },
  grey: {
    '50': '#FAFAFA',
    '100': '#F6F6F6',
    '150': '#EEEEEE',
    '200': '#E5E5E5',
    '250': '#D9D9D9',
    '300': '#CCCCCC',
    '400': '#B2B2B2',
    '450': '#A5A5A5',
    '500': '#999999',
    '600': '#7F7F7F',
    '650': '#7f7f7f',
    '700': '#666666',
    blueGrey: '#0C2433',
    lightgray9: '#dbdbdb'
  } as Partial<any>,
  divider: '#E5E5E5',
  success: {
    main: '#05A019',
    '100': '#e6f5e8',
    '200': '#cdecd1',
    '300': '#b4e2ba'
  },
  warning: {
    main: '#ddaa00',
    '100': '#fcf6e5',
    '200': '#f8eecc',
    '300': '#f5e5b2'
  },
  error: {
    main: '#e42e38',
    '100': '#fceaeb',
    '200': '#fad5d7',
    '300': '#f7c0c3'
  },
  hover: {
    primary: '#024462'
  },
  background: { paper: 'white' },
  plans: {
    academicPlan: {
      primary: '#cc9c00',
      text: undefined
    }
  }
}
